import makeRequest from "rdx/utils/makeRequest";
import { all, put } from "redux-saga/effects";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "../messages";

function* unassignUser(action) {
  const { teamId, userId } = action.payload;
  const { success, data, error } = yield* makeRequest.post(`/sales_teams/${teamId}/unassign`, { user_id: userId });
  if (success && data) {
    yield all([
      put(actions.getTeams()),
      put(actions.getSellers()),
      put(actions.getAvailableSupport()),
      put(actions.setAlertMessageVisible({ message: messages.SUCCESS_UNASSIGNING_USER, severity: "success" })),
    ]);
  } else {
    return getErrorActions({
      error,
      message: messages.ERROR_UNASSIGNING_USER,
    });
  }

  return null;
}

export default unassignUser;
